import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Table, Dropdown} from 'semantic-ui-react';
import Pagination from '../../Pagination';
import moment from 'moment';
import {arrayUniqBy} from '../../../helpers/immutable/array';
import numeral from 'numeral';

class PastPaymentList extends Component {
    constructor(props){
        super(props);
        this.state={
            activePage: 1,
            itemsPerPage: 5,
            startIndex: 0,
            endIndex: 5,
            filter: null
        };
        this.onPaginate = this.onPaginate.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.filteredItems = this.filteredItems.bind(this);
        this.filters = this.filters.bind(this);
        this.onClearFilter = this.onClearFilter.bind(this);
    }
    onPaginate({activePage, startIndex, endIndex}){
        this.setState({activePage, startIndex, endIndex});
    }
    onFilter(e, {value}){
        this.setState({filter: value});
    }
    onClearFilter(e){
        e.preventDefault();
        this.setState({filter: null});
    }
    filteredItems(){
        const {filter} = this.state;
        const {items} = this.props;
        return filter ? items.filter(item => moment(item.itemDate).year() === filter) : items;
    }
    filters() {
        const {items} = this.props;
        return arrayUniqBy(items.map(item => {
            const date = moment(item.itemDate);
            return {text:date.year(), value: date.year() };
        }), 'value');
    }
    render() {
        const {activePage, itemsPerPage, startIndex, endIndex} = this.state;
        const items = this.filteredItems();
        const page = items.slice(startIndex, endIndex);
        const filter = this.filters();
        return (
            <Table celled unstackable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan="4" className="filter">
                            {this.state.filter ? <a href="/#" onClick={this.onClearFilter}>clear</a> : null} <Dropdown selection placeholder="Filter..." options={filter} onChange={this.onFilter} value={this.state.filter} />
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell>Transaction Date</Table.HeaderCell>
                        <Table.HeaderCell>Description</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>
                        <Table.HeaderCell>Balance</Table.HeaderCell>
                    </Table.Row>
                </Table.Header> 
                <Table.Body>
                    {page.map((item, key) => 
                        <Table.Row key={key}>
                            <Table.Cell>
                                {moment(item.itemDate).format('L')}
                            </Table.Cell>
                            <Table.Cell>
                                {item.description}
                            </Table.Cell>
                            <Table.Cell>
                                {numeral(item.itemType === 2 ? item.paymentAmount : item.billedAmount).format('0,0.00')}
                            </Table.Cell>
                            <Table.Cell>
                                {numeral(item.balance).format('0,0.00')}
                            </Table.Cell>
                        </Table.Row>
                    )}
                </Table.Body>
                <Table.Footer>
                <Table.Row>
                <Table.HeaderCell colSpan="4">
                    <Pagination 
                        activePage={activePage}
                        itemsPerPage={itemsPerPage}
                        totalItems={items.length}
                        pageRangeDisplayed={5}
                        floated="right"
                        onPaginate={this.onPaginate}
                        />    
                </Table.HeaderCell>
            </Table.Row>
                </Table.Footer>
            </Table>        
        );
    }
}

PastPaymentList.propTypes = {
    items: PropTypes.array,
};

export default PastPaymentList;